// extracted by mini-css-extract-plugin
export const root = "project-list-module--root--IGYeA";
export const item = "project-list-module--item--3K50Z";
export const title = "project-list-module--title--MPKFF";
export const desc = "project-list-module--desc--3mhQL";